"use strict";
export default {
  createForDocumentBatch(documentBatchId) {
    return $.post(
      "/api/document_batch_views/entered",
      { document_batch_id: documentBatchId }
    );
  },
  markAsExited(documentBatchViewId) {
    return $.post("/api/document_batch_views/" + documentBatchViewId + "/left");
  }
};
